import {Component, OnInit} from '@angular/core';
import {CpProvisionTypeMatrixBaseComponent} from '../base/cp-provision-type-matrix-base.component';

/**
 * Side view of the Provisionsmatrix OBC (`uiMode = 'side' | 'mini-side'`).
 *
 * THE mode of this OBC, not a secondary one: the inheritance-chain chip of the Beratersicht opens
 * `cp.ProvisionTypeMatrix` with `uiMode = 'side'` into the LEFT drawer, deliberately, so that the
 * selection, the key date, the filters and the open row expansions of the Beratersicht survive the
 * lookup. Everything this view does follows from the drawer being narrow and its height belonging
 * to the host:
 *
 *   - the row table runs on the COMPACT column set (five instead of twelve), and
 *   - it brings its OWN overflow container, so a too-wide or too-long table scrolls INSIDE the
 *     drawer instead of pushing it around.
 *
 * Both are decided in {@link CpProvisionTypeMatrixOverviewComponent} through `[compact]="true"`;
 * this class only chooses the variant.
 */
@Component({
    selector: 'cp-provision-type-matrix-side',
    templateUrl: './cp-provision-type-matrix-side.component.html',
    styleUrls: ['./cp-provision-type-matrix-side.component.scss'],
    standalone: false
})
export class CpProvisionTypeMatrixSideComponent extends CpProvisionTypeMatrixBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
